import { engineRequest } from './http';

export const getWorkingHours = () =>
  engineRequest({ path: '/calendar/working-hours' });

// A list of { weekday, is_open, start, end }; days not sent keep their value.
export const putWorkingHours = rows =>
  engineRequest({ method: 'put', path: '/calendar/working-hours', data: rows });

export const listHolidays = params =>
  engineRequest({ path: '/calendar/holidays', params });

export const createHoliday = fields =>
  engineRequest({ method: 'post', path: '/calendar/holidays', data: fields });

export const updateHoliday = (id, fields) =>
  engineRequest({
    method: 'put',
    path: `/calendar/holidays/${id}`,
    data: fields,
  });

export const deleteHoliday = id =>
  engineRequest({ method: 'delete', path: `/calendar/holidays/${id}` });
